import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: localStorage.getItem("token")
    ? JSON.parse(localStorage.getItem("token"))
    : null,
};
export const userSlice = createSlice({
  initialState,
  name: "token",
  reducers: {
    setToken: (state, action) => {
      localStorage.setItem("token", JSON.stringify(action.payload));
      state.token = action.payload;
    },
  },
});
export default userSlice.reducer;
export const { setToken } = userSlice.actions;

export const currentToken = (state) => state?.User?.token;
